import { Menu, type MenuProps } from 'antd'

export type MenuCustomProps = MenuProps

export default function MenuCustom(props: MenuCustomProps) {
  return <Menu {...props} />
}
